import axios from "axios";
import React, {
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setOrderId,
  saveTrnsactionDetails,
  setPaytmDataInStore,
} from "../../redux/payment_gateway/action";
import "./PaytmPayment.scss";
import { url_299 } from "../api_services";
import { extractOrderId, savePendingOrderId } from "./paytmHelpers";
import EmailUpdateModal from "../../containers/logged_user_components/user_edit_profile/user_edit_profile_content_component/update_email/EmailUpdateModal";
import uiActions from "../../redux/ui/action";
import {
  trackWebEngagePaymentFailed,
  trackWebEngagePaymentInitiated,
  saveWebEngagePaymentContext,
} from "../webengage/webengageService";

const PaytmPayment = forwardRef((props, ref) => {
  const {
    packageDetails,
    amount,
    paymentAction,
    saveTransactionAction,
    setPaytmDataInStore,
    startLoading,
    finishLoading,
    userData,
    buttonText,
    buttonClass,
    is_amrit,
    addon_products,
    orderId,
    couponCode,
    deltaUpgradePayload,
    disabled = false,
  } = props;

  const [emailStatus, setEmailStatus] = useState({
    showEmailModal: false,
    emailUpdated: false,
  });

  const [isInitiating, setIsInitiating] = useState(false);
  const history = useHistory();

  const handleOpen = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: true,
    }));
  };

  const handleClose = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: false,
    }));
  };

  const { name, mobile, email, address, batch_id, user_id } = userData || {};
  const addonProductsIds = addon_products
    ? addon_products.map((pkg) => pkg.package_id).join(",")
    : "";

  const updateOrderAndTransactionState = (responseData) => {
    const orderIdFromResponse =
      responseData?.order_id || responseData?.Order_Id || "";
    paymentAction(orderIdFromResponse);
    setPaytmDataInStore(responseData);
    saveTransactionAction({
      course_id: userData?.targets?.[0]?.course_id || "",
      batch_id,
      package_id: packageDetails?.package_id ? packageDetails?.package_id : "",
      txn_amount: amount,
      txn_discount_amount: packageDetails?.discount ? packageDetails.discount : "",
      txn_date: new Date().toISOString().replace("T", " ").substring(0, 19),
      package_duration: packageDetails?.duration ? packageDetails.duration : "",
      txnid: orderIdFromResponse,
      addon_products: addonProductsIds,
    });
    return responseData;
  };

  const buildInitiatePayload = () => {
    const productId = packageDetails?.package_id || packageDetails?.p_id;

    const payload = {
      user_id,
      product_id: productId,
      platform: "WEB",
      // Ask backend/Paytm to return users to the SPA status page (not raw callback JSON).
      website: `${window.location.origin}/payment_gateway`,
      callback_url: `${window.location.origin}/payment_gateway?payment_return=1`,
      redirect_url: `${window.location.origin}/payment_gateway?payment_return=1`,
      frontend_return_url: `${window.location.origin}/payment_gateway?payment_return=1`,
    };

    if (amount !== undefined && amount !== null && amount !== "") {
      payload.total_price = String(amount);
    }

    if (orderId && couponCode) {
      payload.order_id = orderId;
    }

    if (couponCode) {
      payload.coupon_code = couponCode;
    }

    if (deltaUpgradePayload && typeof deltaUpgradePayload === "object") {
      payload.deltaupgrade_payload = deltaUpgradePayload;
      if (deltaUpgradePayload.transaction_type) {
        payload.transaction_type = deltaUpgradePayload.transaction_type;
      }
    }

    return payload;
  };

  const getProgramDetails = () => {
    const parts = [
      packageDetails?.description,
      packageDetails?.short_description,
      packageDetails?.duration
        ? `Duration: ${packageDetails.duration}`
        : null,
    ].filter(Boolean);
    return parts.length ? parts.join(" | ") : undefined;
  };

  const getPaymentEventAttributes = (additionalAttributes = {}) => {
    const productId = packageDetails?.package_id || packageDetails?.p_id;
    const programName =
      packageDetails?.package_name ||
      packageDetails?.name ||
      packageDetails?.title;
    const mrp = packageDetails?.amount ?? amount;
    const specialPrice =
      packageDetails?.special_price ??
      packageDetails?.discounted_price ??
      amount;
    const couponMode =
      packageDetails?.coupon_mode ||
      packageDetails?.coupon_type ||
      undefined;
    const discountAmount =
      packageDetails?.discount ??
      (mrp != null && amount != null ? Number(mrp) - Number(amount) : undefined);

    return {
      product_id: productId,
      product_name: programName,
      program_name: programName,
      program_details: getProgramDetails(),
      program_price: mrp,
      final_price: amount,
      special_price: specialPrice,
      coupon_code: couponCode || undefined,
      coupon_mode: couponMode,
      discount_amount: discountAmount,
      total_amount: amount,
      source: "web",
      amount,
      ...additionalAttributes,
    };
  };

  const initiatePaytm = async () => {
    const payload = buildInitiatePayload();
    console.log("[Paytm][initiate] request payload", payload);
    const response = await axios.post(url_299, payload);
    console.log("[Paytm][initiate] response", {
      status: response.data?.status,
      message: response.data?.message,
      dataKeys: Object.keys(response.data?.data || response.data || {}),
      orderId: extractOrderId(response.data?.data || response.data || {}),
      mid: response.data?.data?.mid || response.data?.mid,
      hasTxnToken: Boolean(
        response.data?.data?.txnToken ||
          response.data?.data?.txn_token ||
          response.data?.txnToken
      ),
      paymentUrl:
        response.data?.data?.payment_url ||
        response.data?.data?.payment_link ||
        response.data?.payment_url,
    });
    if (response.data.status === 200) {
      const responseData = response.data?.data || response.data;
      return updateOrderAndTransactionState(responseData);
    }
    console.warn("[Paytm][initiate] non-200 status", response.data);
    return null;
  };

  const getPaytmData = async () => null;

  const navigateToPaymentStatusPage = (paytmData) => {
    const orderIdValue = extractOrderId(paytmData);
    console.log("[Paytm][initiate] navigate to gateway", {
      orderId: orderIdValue,
      path: `/payment_gateway?order_id=${orderIdValue}&await_payment=1`,
    });
    if (!orderIdValue) return false;

    savePendingOrderId(orderIdValue);
    history.push(
      `/payment_gateway?order_id=${encodeURIComponent(
        orderIdValue
      )}&await_payment=1`
    );
    return true;
  };

  const stopPaymentLoading = () => {
    setIsInitiating(false);
    finishLoading();
  };

  const initiateAndPay = async () => {
    if (isInitiating) return;
    if (!user_id) return;

    const productId = packageDetails?.package_id || packageDetails?.p_id;
    if (!productId) return;

    if (!validateProfileData()) return;

    console.log("[Paytm][initiate] start", { user_id, productId, amount });
    setIsInitiating(true);
    startLoading();

    try {
      const localPaytmData = await initiatePaytm();
      if (!localPaytmData) {
        console.warn("[Paytm][initiate] failed — no order data");
        trackWebEngagePaymentFailed(
          getPaymentEventAttributes({
            reason: "Payment initiation returned no order data",
          })
        );
        stopPaymentLoading();
        return;
      }

      const orderIdValue = extractOrderId(localPaytmData);
      const initiatedAttrs = getPaymentEventAttributes({
        order_id: orderIdValue,
        transaction_id: orderIdValue,
      });
      saveWebEngagePaymentContext(initiatedAttrs);
      trackWebEngagePaymentInitiated(initiatedAttrs);
      navigateToPaymentStatusPage(localPaytmData);
      stopPaymentLoading();
    } catch (err) {
      console.error("[Paytm][initiate] error", err?.response?.data || err);
      trackWebEngagePaymentFailed(
        getPaymentEventAttributes({
          reason: err?.response?.data?.message || err?.message,
        })
      );
      stopPaymentLoading();
    }
  };

  useImperativeHandle(ref, () => ({
    getPaytmData,
  }));

  const validateProfileData = () => {
    if (is_amrit || packageDetails?.is_subscribe) return true;

    const fieldsToCheck = [
      { field: name, label: "name" },
      { field: mobile, label: "mobile number" },
      { field: email, label: "email" },
      { field: address?.state, label: "state" },
      { field: address?.city, label: "city" },
    ];
    const updatedFields = fieldsToCheck.filter(
      (element) =>
        element.field === "" ||
        element.field === null ||
        element.field === undefined
    );

    if (updatedFields.length > 0) {
      const missingFields = updatedFields.map((item) => item.label).join(", ");

      const missingEmail = updatedFields.some((item) => item.label === "email");
      if (missingEmail) {
        handleOpen();
        return false;
      }

      alert(
        `Please update the following in your profile before payment: ${missingFields}`
      );
      history.push("/profile");
      return false;
    }
    window.onbeforeunload = null;
    return true;
  };

  const payButtonLabel = isInitiating
    ? "Processing..."
    : buttonText?.length !== 0
    ? buttonText
    : "Pay Now";

  return (
    <>
      <button
        type="button"
        onClick={initiateAndPay}
        className={buttonClass?.length !== 0 ? buttonClass : "pay_now"}
        disabled={isInitiating || disabled}
      >
        {payButtonLabel}
      </button>
      {emailStatus?.showEmailModal && (
        <EmailUpdateModal
          isEmailModalOpen={emailStatus.showEmailModal}
          closeEmailModal={handleClose}
        />
      )}
    </>
  );
});

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    userData: state.auth.user,
    orderId: state.paymentReducer.orderId,
    user_id: state.auth.user.user_id,
    is_amrit: state.auth.user.is_amrit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    paymentAction: (payload) => dispatch(setOrderId(payload)),
    saveTransactionAction: (payload) =>
      dispatch(saveTrnsactionDetails(payload)),
    setPaytmDataInStore: (payload) =>
      dispatch(setPaytmDataInStore(payload)),
    startLoading: () => dispatch(uiActions.startLoading()),
    finishLoading: () => dispatch(uiActions.finishLoading()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaytmPayment);
